export default __webpack_public_path__ + "static/image4-5c2da37c238e1c02156e63c21610494b.gif";